export const TRACK_SCREEN_HEADER = "My Orders";
export const BILL_SUMMARY_SCREEN_HEADER = "Bill Details";
export const BILL_SUMMARY_PENDING_SCREEN_HEADER = "Generate Bill";

export const TRACK_POLLING_INTERVAL = 60000;
export const TRACK_ORDER_ENDPOINT = "/api/v2/json/track/card";

export const EMPTY_TRACK_TYPES = [
    "type.googleapis.com/swiggy.presentation.dinersone.v1.ParentOrderListWidget",
    "type.googleapis.com/swiggy.presentation.dinersone.v1.ParentOrderWidget",
    "type.googleapis.com/swiggy.gandalf.widgets.v2.ErrorResponse",
];

export const EMPTY_TRACK_SCREEN = {
    heading: "Uh, Oh! Your order list is empty :(",
    description: "Time to order something tasty!",
    ctaText: "Start ordering",
    img: "portal/static-assets/hcms/dineout/qr/empty_cart.png",
};
